/* ==========================================================================
   PW HOMEPAGE B (v32, 28 Sep 2026)
   Starfield (twinkle + shooting stars), hero parallax, ticker pause, rail,
   reveal on scroll, keyed mascots in the pack band and quick add.
   Everything respects prefers-reduced-motion. No dependencies.
   ========================================================================== */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CDN = 'https://cdn.shopify.com/s/files/1/0888/1628/8064/files/';

  /* ---------- starfield ---------- */
  function Sky(c, o) {
    this.c = c; this.x = c.getContext('2d');
    this.o = Object.assign({ density: 1, shoot: true, drift: 0, gold: true }, o || {});
    this.shots = []; this.next = 1200; this.run = false; this.last = 0; this.mx = 0; this.my = 0; this.vis = false;
    var self = this;
    this.resize();
    window.addEventListener('resize', function () { clearTimeout(self.rt); self.rt = setTimeout(function () { self.resize(); }, 150); });
    new IntersectionObserver(function (es) {
      self.vis = es[0].isIntersecting;
      if (self.vis && !self.run && !RM) { self.run = true; self.last = performance.now(); requestAnimationFrame(function (t) { self.tick(t); }); }
    }).observe(c);
  }
  Sky.prototype.resize = function () {
    var d = Math.min(window.devicePixelRatio || 1, 2), r = this.c.getBoundingClientRect();
    if (!r.width || !r.height) return;
    this.w = r.width; this.h = r.height;
    this.c.width = Math.round(r.width * d); this.c.height = Math.round(r.height * d);
    this.x.setTransform(d, 0, 0, d, 0, 0);
    var n = Math.min(520, Math.round(r.width * r.height / 3600 * this.o.density));
    this.s = [];
    for (var i = 0; i < n; i++) {
      var big = Math.random() < 0.035, z = Math.random(), col = '255,252,244', q = Math.random();
      if (q < 0.22) col = '159,180,255'; else if (this.o.gold && q < 0.27) col = '238,196,110';
      this.s.push({ x: Math.random() * this.w, y: Math.random() * this.h, r: big ? 1.2 + Math.random() * 0.9 : 0.25 + Math.random() * 0.85, a: 0.25 + Math.random() * 0.6, sp: 0.4 + Math.random() * 1.8, ph: Math.random() * 6.28, big: big, z: z, col: col });
    }
    if (RM) this.draw(0, 0);
  };
  Sky.prototype.spawn = function () {
    var fromL = Math.random() < 0.5, ang = 0.28 + Math.random() * 0.32;
    this.shots.push({ x: fromL ? Math.random() * this.w * 0.6 : this.w * 0.4 + Math.random() * this.w * 0.6, y: Math.random() * this.h * 0.45, dir: fromL ? 1 : -1, ang: ang, v: 0.9 + Math.random() * 0.7, len: 140 + Math.random() * 180, life: 0, max: 900 + Math.random() * 700 });
  };
  Sky.prototype.draw = function (t, dt) {
    var x = this.x; if (!this.s) return;
    x.clearRect(0, 0, this.w, this.h);
    var ts = t / 1000, ox = this.mx * 6, oy = this.my * 6;
    for (var i = 0; i < this.s.length; i++) {
      var s = this.s[i];
      if (this.o.drift) { s.x += this.o.drift * (0.3 + s.z) * dt * 0.02; if (s.x > this.w + 4) s.x = -4; }
      var tw = 0.55 + 0.45 * Math.sin(ts * s.sp + s.ph), al = s.a * tw, px = s.x + ox * s.z, py = s.y + oy * s.z;
      x.fillStyle = 'rgba(' + s.col + ',' + al + ')'; x.beginPath(); x.arc(px, py, s.r, 0, 6.283); x.fill();
      if (s.big) {
        var g = x.createRadialGradient(px, py, 0, px, py, s.r * 7);
        g.addColorStop(0, 'rgba(' + s.col + ',' + al * 0.45 + ')'); g.addColorStop(1, 'rgba(' + s.col + ',0)');
        x.fillStyle = g; x.beginPath(); x.arc(px, py, s.r * 7, 0, 6.283); x.fill();
        var L = s.r * (5 + tw * 5);
        x.strokeStyle = 'rgba(' + s.col + ',' + al * 0.55 + ')'; x.lineWidth = 0.6;
        x.beginPath(); x.moveTo(px - L, py); x.lineTo(px + L, py); x.moveTo(px, py - L); x.lineTo(px, py + L); x.stroke();
      }
    }
    if (!this.o.shoot || RM) return;
    this.next -= dt;
    if (this.next <= 0) { this.spawn(); var me = this; if (Math.random() < 0.18) setTimeout(function () { me.spawn(); }, 260); this.next = 2200 + Math.random() * 3800; }
    var keep = [];
    for (var j = 0; j < this.shots.length; j++) {
      var sh = this.shots[j]; sh.life += dt; var p = sh.life / sh.max; if (p >= 1) continue;
      var d = sh.v * sh.life, hx = sh.x + Math.cos(sh.ang) * d * sh.dir, hy = sh.y + Math.sin(sh.ang) * d;
      var fade = p < 0.15 ? p / 0.15 : p > 0.7 ? (1 - p) / 0.3 : 1, len = sh.len * Math.min(1, p * 3);
      var tx = hx - Math.cos(sh.ang) * len * sh.dir, ty = hy - Math.sin(sh.ang) * len;
      var lg = x.createLinearGradient(hx, hy, tx, ty);
      lg.addColorStop(0, 'rgba(255,250,235,' + 0.95 * fade + ')'); lg.addColorStop(0.25, 'rgba(200,214,255,' + 0.45 * fade + ')'); lg.addColorStop(1, 'rgba(159,180,255,0)');
      x.strokeStyle = lg; x.lineWidth = 1.6; x.lineCap = 'round'; x.beginPath(); x.moveTo(hx, hy); x.lineTo(tx, ty); x.stroke();
      var hg = x.createRadialGradient(hx, hy, 0, hx, hy, 9);
      hg.addColorStop(0, 'rgba(255,246,220,' + fade + ')'); hg.addColorStop(0.4, 'rgba(242,181,68,' + 0.35 * fade + ')'); hg.addColorStop(1, 'rgba(242,181,68,0)');
      x.fillStyle = hg; x.beginPath(); x.arc(hx, hy, 9, 0, 6.283); x.fill();
      keep.push(sh);
    }
    this.shots = keep;
  };
  Sky.prototype.tick = function (t) {
    if (!this.vis) { this.run = false; return; }
    var self = this;
    var dt = Math.min(50, t - this.last); this.last = t; this.draw(t, dt);
    requestAnimationFrame(function (tt) { self.tick(tt); });
  };

  function boot() {
    var skies = [];
    document.querySelectorAll('canvas[data-pwb-sky]').forEach(function (c) {
      var o = {}; try { o = JSON.parse(c.getAttribute('data-pwb-sky') || '{}'); } catch (e) {}
      var s = new Sky(c, o); c._pwbSky = s; skies.push(s);
    });

    /* ---------- hero ---------- */
    var hero = document.querySelector('.pwb-hero');
    if (hero) {
      setTimeout(function () { hero.classList.add('is-loaded'); }, 60);
      var sky = hero.querySelector('canvas[data-pwb-sky]'); sky = sky && sky._pwbSky;
      var tiles = [].slice.call(hero.querySelectorAll('.pwb-tile'));
      var tmx = 0, tmy = 0, cmx = 0, cmy = 0, heroVis = true;
      new IntersectionObserver(function (es) {
        heroVis = es[0].isIntersecting;
        document.body.classList.toggle('pwb-hero-inview', heroVis);
      }).observe(hero);
      if (!RM && window.matchMedia('(hover:hover)').matches) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          tmx = (e.clientX - r.left) / r.width - 0.5; tmy = (e.clientY - r.top) / r.height - 0.5;
          hero.style.setProperty('--mx', e.clientX - r.left + 'px'); hero.style.setProperty('--my', e.clientY - r.top + 'px');
        });
      }
      var neb = document.querySelector('.pwb-par');
      var loop = function () {
        requestAnimationFrame(loop);
        if (document.hidden) return;
        if (heroVis) {
          cmx += (tmx - cmx) * 0.06; cmy += (tmy - cmy) * 0.06;
          if (sky) { sky.mx = cmx; sky.my = cmy; }
          var now = performance.now();
          for (var i = 0; i < tiles.length; i++) {
            var d = +tiles[i].getAttribute('data-depth') || 8, m = tiles[i].firstElementChild;
            if (m) m.style.transform = 'translate3d(' + (-cmx * d) + 'px,' + (-cmy * d + Math.sin(now / 2600 + i) * 3) + 'px,0)';
          }
        }
        if (neb) {
          var r = neb.parentElement.getBoundingClientRect();
          if (r.bottom > 0 && r.top < innerHeight) neb.style.transform = 'translate3d(0,' + (r.top + r.height / 2 - innerHeight / 2) * -0.08 + 'px,0)';
        }
      };
      if (!RM) requestAnimationFrame(loop);
    }

    /* ---------- ticker ---------- */
    document.querySelectorAll('[data-pwb-ticker]').forEach(function (tk) {
      var pb = tk.querySelector('.pwb-pause'), pi = pb && pb.querySelector('svg');
      if (!pb) return;
      function setP(p) {
        tk.classList.toggle('is-paused', p);
        pb.setAttribute('aria-pressed', p ? 'true' : 'false');
        pb.setAttribute('aria-label', p ? 'Play scrolling text' : 'Pause scrolling text');
        pi.innerHTML = p ? '<path d="M2 0L11 6L2 12Z" fill="currentColor"/>' : '<rect x="1" y="0" width="3" height="12" fill="currentColor"/><rect x="8" y="0" width="3" height="12" fill="currentColor"/>';
      }
      pb.addEventListener('click', function () { setP(!tk.classList.contains('is-paused')); });
      if (RM) setP(true);
    });

    /* ---------- rail ---------- */
    document.querySelectorAll('[data-pwb-railwrap]').forEach(function (w) {
      var rail = w.querySelector('.pwb-rail'), pv = w.querySelector('[data-pwb-prev]'), nx = w.querySelector('[data-pwb-next]'), pg = w.querySelector('.pwb-prog i');
      if (!rail) return;
      function step() { var c = rail.querySelector('.pwb-card'); return c ? c.offsetWidth + 20 : 300; }
      if (pv) pv.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: RM ? 'auto' : 'smooth' }); });
      if (nx) nx.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: RM ? 'auto' : 'smooth' }); });
      function rp() {
        var m = rail.scrollWidth - rail.clientWidth, f = m ? rail.scrollLeft / m : 0, ww = rail.clientWidth / rail.scrollWidth;
        if (pg) { pg.style.width = ww * 100 + '%'; pg.style.transform = 'translateX(' + f * (1 / ww - 1) * 100 + '%)'; }
        if (pv) pv.disabled = rail.scrollLeft < 4;
        if (nx) nx.disabled = rail.scrollLeft > m - 4;
      }
      rail.addEventListener('scroll', rp, { passive: true }); window.addEventListener('resize', rp); rp();
    });

    /* ---------- reveal ---------- */
    var rv = document.querySelectorAll('.pwb-rv');
    if ('IntersectionObserver' in window && !RM) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      rv.forEach(function (el) { io.observe(el); });
    } else rv.forEach(function (el) { el.classList.add('is-in'); });

    /* ---------- mascots in the pack band (green screen keyed in a canvas) ---------- */
    function keyGreen(src) {
      return new Promise(function (res, rej) {
        var i = new Image(); i.crossOrigin = 'anonymous';
        i.onload = function () {
          try {
            var c = document.createElement('canvas'); c.width = i.naturalWidth; c.height = i.naturalHeight;
            var x = c.getContext('2d'); x.drawImage(i, 0, 0);
            var d = x.getImageData(0, 0, c.width, c.height), p = d.data;
            for (var k = 0; k < p.length; k += 4) {
              var r = p[k], g = p[k + 1], b = p[k + 2], m = Math.max(r, b), gr = g - m;
              if (gr > 18) { var a = Math.max(0, Math.min(1, 1 - (gr - 18) / 50)); p[k + 3] = a * 255; p[k + 1] = Math.min(g, m + 8); }
            }
            x.putImageData(d, 0, 0); res(c.toDataURL());
          } catch (e) { rej(e); }
        };
        i.onerror = rej; i.src = CDN + src + '?width=600';
      });
    }
    var mascs = document.querySelectorAll('.pwb-masc[data-src]');
    if (mascs.length) {
      var packIo = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; packIo.disconnect();
        mascs.forEach(function (m) {
          keyGreen(m.getAttribute('data-src')).then(function (u) { m.src = u; m.classList.add('is-ready'); }).catch(function () { m.remove(); });
        });
      }, { rootMargin: '400px 0px' });
      packIo.observe(mascs[0].closest('.pwb-pack') || mascs[0]);
    }

    /* ---------- toast ---------- */
    var toastEl, tt;
    function toast(html) {
      if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'pwb-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
      toastEl.innerHTML = html; toastEl.classList.add('is-on');
      clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
    }

    /* ---------- quick add (single variant products only) ---------- */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.pwb-add[data-variant]');
      if (!b) return;
      e.preventDefault();
      if (b.getAttribute('aria-busy') === 'true') return;
      b.setAttribute('aria-busy', 'true');
      var drawer = document.querySelector('cart-drawer');
      var fd = new FormData(); fd.append('id', b.getAttribute('data-variant')); fd.append('quantity', '1');
      fd.append('sections', drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble'); fd.append('sections_url', window.location.pathname);
      window.fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          b.removeAttribute('aria-busy');
          if (!res.ok || res.j.status) { toast((res.j && res.j.description) || 'That did not work. Try the product page.'); return; }
          if (drawer && typeof drawer.renderContents === 'function') {
            try { drawer.classList.remove('is-empty'); drawer.renderContents(res.j); return; } catch (err) {}
          }
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && res.j.sections && res.j.sections['cart-icon-bubble']) {
            var tmp = document.createElement('div'); tmp.innerHTML = res.j.sections['cart-icon-bubble'];
            var inner = tmp.querySelector('.shopify-section'); bubble.innerHTML = (inner || tmp).innerHTML;
          }
          toast('<b>Added.</b> ' + (b.getAttribute('data-title') || '') + '. <a href="/cart">View bag</a>');
        })
        .catch(function () { b.removeAttribute('aria-busy'); window.location.href = b.getAttribute('data-url') || '/cart'; });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
